import { Component, OnInit } from '@angular/core';
import { PollService } from 'src/app/core/http/poll/poll.service';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { SchemaService } from 'src/app/shared/services/schema/schema.service';
import { DefaultWidgetRegistry } from 'ngx-schema-form'
import { FormGroup, FormBuilder } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-adm-poll-edit',
  templateUrl: './adm-poll-edit.component.html',
  styleUrls: ['./adm-poll-edit.component.css'],
  
})
export class AdmPollEditComponent implements OnInit {  
  poll_id = null;
  poll;
  pollForm: FormGroup;
  pollFields =[];
  constructor(private pollService: PollService, private route: ActivatedRoute, private _fb: FormBuilder) {
    this.poll_id = this.route.snapshot.paramMap.get("id");
  }

  ngOnInit(): void {
   // this.deleteField();
    this.getPoll();
    this.pollForm = this._fb.group({
      name: [''],
      description: ['']
    })
    
  }

  getPoll() {
    forkJoin([this.pollService.getPollFields(this.poll_id), this.pollService.getCurrentPoll(this.poll_id)]).subscribe( res   => {
      this.poll = res[1];
      if (this.poll) {
        this.pollForm = this._fb.group({
          name: this.poll.name,
          description: this.poll.description
        })
        this.pollForm.valueChanges
        .pipe(
          debounceTime(500),
          distinctUntilChanged()
        )
        .subscribe(()=> {
          this.pollService.EditPoll(this.poll_id, this.pollForm.value)
          .subscribe(); 
        });
      }
      this.pollFields = res[0];
    })
  }
  changePoll() {
  }
    
  
}
